<template>
  <div class="text-row-consume" >
    <div class="header" @click="goDetails(balanceData)">
      <p class="desc-text">{{balanceData.description}}</p>
      <p class="amount-text"> -￥{{balanceData.amount || 0}}</p>
    </div>

    <div class="item-text" @click="goDetails(balanceData)">
      <span class="title">订单编号</span>
      <span>{{balanceData.id }}</span>
    </div>
    <div class="item-text" @click="goDetails(balanceData)">
      <span class="title">创建时间</span>
      <span>{{balanceData.start_time }}</span>
    </div>
    <div class="item-text" @click="goDetails(balanceData)">
      <span class="title">完成时间</span>
      <span>{{balanceData.end_time }}</span>
    </div>
    <div class="item-text" @click="goDetails(balanceData)">
      <span class="title">站点名称</span>
      <span>{{balanceData.station_name }}</span>
    </div>
    <div class="item-text" @click="goDetails(balanceData)">
      <span class="title">站点地址</span>
      <span>{{balanceData.station_address }}</span>
    </div>
    <div class="item-text" @click="goDetails(balanceData)">
      <span class="title">设备id</span>
      <span>{{balanceData.machine_code }}</span>
    </div>
    <div class="item-text" @click="goDetails(balanceData)">
      <span class="title">累计时长</span>
      <span>{{balanceData.timePoor }}</span>
    </div>

    <van-button v-if="balanceData.showRepairButton == 1" class="foot-btn" icon="setting-o" size="small" color="#2998FF" block @click="applyRepair(balanceData)">申请报修</van-button>

  </div>
</template>
 
<script>
export default {
  name: "TextRowBalance",
  props: {
    balanceData: {
      type: Object,
      default: {},
    },
  },
  components: {},
  data() {
    return {
      // balanceData: {
      // id: "订单号",
      // start_time: "开始时间",
      // end_time: "结束时间",
      // timePoor: "累计时长",
      // amount: "订单金额",
      // created_time: "创建时间",
      // description: "明细",
      // station_name: "站点名称",
      // station_address: "站点地址",
      // machine_code: "设备号",
      // }
    };
  },
  created() {},
  mounted() {},
  methods: {
     goDetails(Data) {  
        this.$router.push({
          name: "consume-log-details",
          query: {
            id: Data.id,
          },
        }); 
    },
      applyRepair(Data) {
      let _this = this;
      _this.$router.push({
        name: "apply-repair",
        query: {
          orderId: Data.id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.text-row-consume {
  width: 100%;
  // height: 357px;
  background-color: #fff;
  padding: 15px 20px;
  border-radius: 10px;
  margin: 10px 0;
  border-bottom: 1px solid #eeeeee;

  .header {
    text-align: center;
    width: 100%;

    .desc-text {
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #333333;
      margin-bottom: 20px;
    }
    .amount-text {
      font-size: 23px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #333333;
    }
  }
  .item-text {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 13px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #333333;
    margin-top: 23px;

    .title {
      font-size: 13px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #999999;
    }
  }

  .in-text {
    color: #333333;
  }
  .out-text {
    color: #f03535;
  }

  .foot-btn{
    margin-top: 10px;
    border-radius: 10px;
  }
}
</style>
